import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

export const forgotPassword = createAsyncThunk('forgot-password', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/forgot-password', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const resetPassword = createAsyncThunk('reset-password', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.post(`/api/reset-password`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type ErrorState = {
  errors: any
}

const initialState: ErrorState = {
  errors: '',
}

export const passwordSlice = createSlice({
  name: 'password',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(forgotPassword.fulfilled, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(resetPassword.fulfilled, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = passwordSlice.actions
export default passwordSlice.reducer
